<template>
    <div class="main">
        <div class="head">
            <div class="left">
                深圳伊阁数字传媒有限公司
            </div>
            <div class="right btn" @click="showFunc(true)">
                Contact Us
            </div>
        </div>
        <div class="content">
            <div class="title h4">
                以数字化技术为核心驱动
            </div>
            <div class="title h3">
                为企业赋能增效的创新型数字营销科技公司
            </div>
            <div class="name">
                深圳伊阁数字传媒有限公司
            </div>
            <div class="btn start">Get Started</div>
        </div>
        <div class="number">
            <div class="cards">
                <div class="item">
                    <img src="@/assets/icon1.png" alt="">
                    <div class="num">
                        3000+
                    </div>
                    <div class="desc">
                        数据库赋能
                    </div>
                </div>
                <div class="item">
                    <img src="@/assets/icon2.png" alt="">
                    <div class="num">
                        600+
                    </div>
                    <div class="desc">
                        服务品牌认可
                    </div>
                </div>
                <div class="item">
                    <img src="@/assets/icon3.png" alt="">
                    <div class="num">
                        3000+
                    </div>
                    <div class="desc">
                        数据库赋能
                    </div>
                </div>
            </div>
            <div class="btn" @click="showFunc(true)">
                Contact Us
            </div>
        </div>
        <div class="titleBox">
            <div class="name">
                案例展示
            </div>
            <div class="eng">
                Case presentation
            </div>
        </div>
        <div class="case">
            <div class="list">
                <div class="item">
                    <img src="@/assets/case1.jpg" alt="">
                </div>
                <div class="item">
                    <img src="@/assets/case2.jpg" alt="">
                </div>
                <div class="item">
                    <img src="@/assets/case3.jpg" alt="">
                </div>
            </div>
            <div class="back"></div>
        </div>
        <div class="titleBox">
            <div class="name">
                服务品牌
            </div>
            <div class="eng">
                Service brand
            </div>
        </div>
        <div class="brand">
            <img src="@/assets/brand.jpg" alt="">
        </div>
        <div class="bottom">
            <div class="info">
                <div class="company">
                    <div class="name">
                        深圳伊阁数字传媒有限公司
                    </div>
                    <div class="position">
                        <img class="icon" src="@/assets/icon4.png" alt="">
                         <div>
                            深圳市龙华区龙华街道富康社区龙华大道1391号龙华文体中心1层
                         </div>
                    </div>
                </div>
                <div class="contact">
                    <div class="title">
                        Contact
                    </div>
                    <div class="people">
                        <div class="item">
                            <img class="icon" src="@/assets/icon5.png" alt="">
                            何夏明
                        </div>
                        <div class="item">
                            <img class="icon" src="@/assets/icon6.png" alt="">
                            18625027623
                        </div>
                        <div class="item">
                            <img class="icon" src="@/assets/icon7.png" alt="">
                            hexiaming@qq.com
                        </div>
                    </div>
                </div>
            </div>
            <div class="code"><a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2025425615号</a></div>
        </div>
        <div class="iframe" v-show="show">
            <div class="back"></div>
            <div class="info">
                <div class="people">
                    <div class="item">
                        <img class="icon" src="@/assets/icon5.png" alt="">
                        何夏明
                    </div>
                    <div class="item">
                        <img class="icon" src="@/assets/icon6.png" alt="">
                        18625027623
                    </div>
                    <div class="item">
                        <img class="icon" src="@/assets/icon7.png" alt="">
                        hexiaming@qq.com
                    </div>
                </div>
                <div class="btn" @click="showFunc(false)">关闭</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homePage',
    data(){
        return {
            show: false
        }
    },
    methods: {
        showFunc(show){
            this.show = show;
        }
    }
}
</script>
<style scoped>
.main {
    /* width: 1076px;
    margin: 0 auto; */
}
.main .head {
    width: 1076px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 28px;
}
.main .head .left {
    font-size: 14px;
    font-weight: bold;
}
.main .head .right {
    
}
.main .btn {
    cursor: pointer;
    background: #5151fd;
    color: #fff;
    padding: 14px 30px;
    font-weight: 600;
    border-radius: 24px;
}
.main .btn:hover {
    transform: scale(1.06);
}
.main .content {
    width: 1076px;
    margin: 0 auto;
    margin-top: 64px;
    text-align: left;
}
.main .content .title {
    font-weight: 600;
}
.main .content .title.h4 {
    font-size: 32px;
}
.main .content .title.h3 {
    margin-top: 4px;
    font-size: 18px;
}
.main .content .name {
    margin-top: 16px;
    font-size: 12px;
    color: #868484;
}
.main .content .start {
    display: inline-block;
    margin-top: 68px;
}
.main .number {
    padding-top: 220px;
    background-image: url(@/assets/back.png);   
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.main .number .cards {
    width: 1076px;
    margin: 0 auto;
    display: flex;
    justify-content: center;

}
.main .number .cards .item {
    width: 30%;
    /* height: 830px; */
    background: #fff;
    text-align: center;
    margin: 0 12px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.2);
    border-radius: 6px;
}
.main .number .cards .item:hover {
    transform: scale(1.06);
}
.main .number .cards .item img {
    width: 124px;
    height: 124px;
    margin-top: 80px;
}
.main .number .cards .item .num {
    margin-top: 98px;
    color: #5e58f7;
    font-weight: bold;
    font-size: 28px;
}
.main .number .cards .item .desc {
    margin-top: 6px;
    color: #808080;
    font-size: 18px;
    margin-bottom: 104px;
}
.main .number .btn {
    margin-top: 84px;
    display: inline-block;
    margin-bottom: 24px;
}

.main .titleBox {
    margin-top: 84px;
}
.main .titleBox .name {
    font-weight: bold;
    font-size: 30px;
}
.main .titleBox .eng {
    font-size: 12px;
    color: #5e58f7;
    margin-top: 4px;
    font-weight: bold;
}
.main .case {
    width: 1140px;
    margin: 40px auto 0;
    position: relative;
    padding-bottom: 24px;
}
.main .case .list {
    width: 1076px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
}
.main .case .list .item {
    width: 335px;
    height: 500px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.2);
    border-radius: 16px;
    margin: 0 10px;
    padding: 8px;
    background: #fff;
}
.main .case .list .item:hover {
    transform: scale(1.06);
}
.main .case .list .item img {
    width: 100%;
    height: 100%;
    border-radius: 14px;
}
.main .case .back {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 120px;
    background: #eceffa;
    z-index: -1;
    border-radius: 20px;
}
.main .brand {
    width: 1076px;
    margin: 0 auto;
}
.main .brand img {
    width: 100%;
}
.main .bottom {
    width: 100%;
    height: 520px;
    background-image: url(@/assets/back2.png);   
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}
.main .bottom .info {
    padding-top: 200px;
    float: right;
    padding-right: 80px;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    font-weight: bold;
}
.main .bottom .info .company {
    width: 200px;
    margin-right: 80px;
}
.main .bottom .info .company .name {
    font-size: 13px;
    font-weight: bold;
}
.main .bottom .info .company .position {
    margin-top: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.main .bottom .info .icon {
    margin-right: 8px;
}
.main .bottom .info .contact {

}
.main .bottom .info .contact .title {
    font-size: 13px;
    padding-bottom: 16px;
    border-bottom: 1px solid #808080;
}
.main .bottom .info .contact .people {
    padding-top: 24px;
}
.main .bottom .info .contact .people .item {
    line-height: 36px;
    display: flex;
    align-items: center;
}
.main .bottom .code {
    position: absolute;
    right: 80px;
    bottom: 20px;
    font-size: 13px;
    font-weight: bold;
}
.main .bottom .code a {
    color: #333333;
    text-decoration: none;
}
.main .iframe {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
}
.main .iframe .back {
    background: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    z-index: 99;
}
.main .iframe .info {
    width: 340px;
    height: 300px;
    background: #fff;
    z-index: 100;
    position: absolute;
    top: 200px;
    left: calc(50% - 180px);
    border-radius: 12px;
    padding: 40px 60px;
    box-sizing: border-box;
    text-align: center;
}
.main .iframe .info .item {
    line-height: 36px;
    display: flex;
    align-items: center;
}
.main .iframe .info .item .icon {
    margin-right: 8px;
}
.main .iframe .info .btn {
    width: 100px;
    padding: 10px 12px;
    margin: 64px auto 0;
}
</style>